import React from 'react';
import { FaUpload } from 'react-icons/fa';
import PropTypes from 'prop-types';

const New = ({ handleAddNew }) => {
  return (
    <button
      onClick={handleAddNew}
      className="
      text-xl 
      group 
      bg-gradient-to-r from-blue-600 to-purple-600 
      text-white 
      hover:from-purple-600 hover:to-blue-600  
      font-semibold 
      py-3 
      px-6 
      rounded-full 
      shadow-lg 
      hover:shadow-2xl 
      transition-all 
      duration-300 
      flex 
      items-center 
      gap-2
    "
    >
      <FaUpload size={24} className="text-white group-hover:text-yellow-300 transition-colors duration-300" />
      Add New
    </button>

  );
};

New.propTypes = {
  setShowForm: PropTypes.func.isRequired,
};

export default New;